import { ArrowBigLeft } from 'lucide-react';
import React from 'react';

import { Inline, Typography } from '@crossnokaye/ux-common';

import type { PreviewChangeData } from './setting-preview.types';

/**
 * PreviewChange
 *
 * Pure presentational atom that renders a "new value ← old value" indicator.
 * Used inside `PreviewItem` rows and anywhere a compact change display is needed.
 *
 * Both values must be pre-formatted strings — this component does no formatting.
 */
export const PreviewChange = ({
  displayCurrent,
  displayOriginal,
}: PreviewChangeData): React.ReactElement => {
  return (
    <Inline
      wrap={false}
      className="items-center min-w-0 flex-1 justify-end overflow-hidden"
      gap="sm"
    >
      <Typography variant="body" className="min-w-0 truncate text-ckds-input-fg-new">
        {displayCurrent}
      </Typography>
      <ArrowBigLeft className="size-4 shrink-0 text-ckds-input-fg-new" />
      <Typography variant="body" className="min-w-0 truncate text-ckds-input-fg-old">
        {displayOriginal}
      </Typography>
    </Inline>
  );
};
